/** Rows per page in the Domains and Acquisition tables, which page in the browser and offer no other size. */
export const DASHBOARD_TABLE_PAGE_SIZE = 15
